import { useContext, useMemo } from 'react';

import type { CustomRoleTaxonomySelection } from '@revelio/data-access';

import { UserPreferencesContext } from '../userPreferenceContext';

export function useRoleTaxonomySelection():
  | CustomRoleTaxonomySelection
  | undefined {
  const { preferences } = useContext(UserPreferencesContext);

  const selection = useMemo<CustomRoleTaxonomySelection | undefined>(() => {
    const rolePref = preferences.taxonomies?.role as
      | CustomRoleTaxonomySelection
      | 'adaptive'
      | undefined;

    if (!rolePref || rolePref === 'adaptive') {
      // When adaptive, use the effective selection if available (computed
      // by adaptive taxonomy hooks). Return undefined while unresolved so
      // callers can pause queries instead of fetching with {default:true}.
      const effective = preferences.taxonomies
        ?.effectiveRoleTaxonomySelection as
        | CustomRoleTaxonomySelection
        | undefined;
      return effective && typeof effective === 'object'
        ? { ...effective }
        : undefined;
    }
    if (typeof rolePref === 'object') return { ...rolePref };
    return { default: true };
  }, [preferences]);

  return selection;
}
